import { TagIcon } from '@components';
import { altTagPath } from '@paths';
import { GetPostAndMorePostsQuery } from '@/src/generated/graphql';

type AltTag = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<GetPostAndMorePostsQuery['post']>['altTags']
      >['edges']
    >[0]
  >['node']
>;

const notEmptyTag = (
  tag: AltTag
): tag is {
  name: string;
  slug: string;
  id: string;
} => !!tag.name && !!tag.slug;

export const AltTags: React.FC<{
  tags: AltTag[];
}> = ({ tags }) => (
  <div className='flex flex-wrap gap-2'>
    {tags.filter(notEmptyTag).map((tag) => (
      <a
        href={altTagPath(tag.slug)}
        key={tag.slug}
        className='flex items-center gap-2 rounded-lg bg-lightgray px-4 py-2'
      >
        <TagIcon className='h-4 text-secondary2' />
        {tag.name}
      </a>
    ))}
  </div>
);
